/*
 * Copyright (c) 2023-2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Deserializable} from './deserializable';

export class HelpInfo implements Deserializable {

  routeKey: string;
  helpInfoStr: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
